import React from 'react'

import { cn } from 'src/shared/utils/cn'

import FilterGrain from './filter-grain'

interface WebpImageProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  /** The webp image source. Using other image types(e.g. png, jpg, etc.) is ok. */
  src: string
  className?: string
  containerClassName?: string
  /** A fallback image to use if the webp image is not supported. E.g. png, jpg, etc. */
  fallbackSrc?: string
  includeFilterGrain?: boolean
}

/**
 * A component that renders a webp image and a fallback image.
 * Use className to style the image and containerClassName to style the container.
 */
export const WebpImage = ({
  src,
  className,
  containerClassName,
  fallbackSrc,
  includeFilterGrain = false,
  ...props
}: WebpImageProps) => {
  const isWebp = src.toLowerCase().endsWith('.webp')

  return (
    <div className={cn('size-full', includeFilterGrain && 'relative', containerClassName)}>
      <picture>
        {isWebp && <source type="image/webp" srcSet={src} />}
        <img src={fallbackSrc || src} className={cn('size-full object-cover', className)} {...props} />
      </picture>
      {includeFilterGrain && <FilterGrain />}
    </div>
  )
}
